'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auth = require('./auth.component');

var _auth2 = _interopRequireDefault(_auth);

var _auth3 = require('./auth.service');

require('ngstorage/ngStorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginmodule = _angular2.default.module('loginform', [
//uiRouter,
'ngStorage']).component('loginform', _auth2.default).service('AuthService', _auth3.AuthService).name;

exports.default = loginmodule;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/common/auth/auth.js
 **/